import { network } from 'services/network';
import { useQuery } from 'react-query';

const queryFn = () => {
    return network.post('api/bo/getLanguages').then((response) => {
        return response.data;
    });
};
export const useQueryGetLanguageList = () => {
    return useQuery<ISelectOption<string>[], QueryError>({
        queryKey: 'languageList',
        queryFn: () => queryFn(),
    });
};
